import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    tableRightBorder: {
        borderRightWidth: 1,
        borderBottomWidth: 1,
        borderColor: "rgba(0,0,0,0.1)",
        borderStyle: "solid",
        // whiteSpace: "nowrap",
      },
      smallWidth: {
        width: "300px",
        fontWeight: "bold",
        color: "#b499c7",
      },
      goalLabel3: {
        marginBottom: "10px",
        fontSize: "14px",
        fontFamily: "Montserrat",
        fontWeight: "bold",
        color: "#6f59a6",
      },
      tableFont: {
        fontSize: "16px",
        fontFamily: "Montserrat",
       
      },
      tableContainer: {
        padding: "10px",
      },
      lessPadding: {
        padding: "3px 16px",
      },
      wordCounter: {
        textAlign: "right",
        fontfamily: "Montserrat",
        fontSize: "14px",
        marginTop: "4px",
        color: "rgba(0,0,0,0.5)",
      },
      leftTitle: {
        fontSize: "16px",
        fontFamily: "Montserrat",
        fontWeight: "bold",
        color: "#b499c7",
      },
      tooltip: {
        backgroundColor: "rgba(118,95,170,1)",
        padding: "1px",
        maxWidth: "none",
      },
      tooltipArrow: {
        backgroundColor: "rgba(118,95,170,1)",
      },
      flex: {
        display: "flex",
        alignItems: "center",
        padding:"0px 0px"
      },
      flexAcross: {
        display: "flex",
        alignItems: "center",
        padding:"0px 0px",
        [theme.breakpoints.down('md')]: {
          flexDirection: 'column'
        }
      },
      flexAcrossWidth: {
        width: '45%', 
        [theme.breakpoints.down('md')]: {
          width: '100%'
        }
      },
      searchPopup: {
        padding: "15px",
        height: "300px",
        width: "600px",
        overflowY: "scroll",
        [theme.breakpoints.down('md')]: {
          width: '100vw'
        }
      },
      backButton: {
        backgroundColor: "#fff",
        fontFamily: "Montserrat",
        color: "#3ac2d7",
        textTransform: "none",
        width: "200px",
        fontWeight: "bold",
        border: "2px solid #3ac2d7",
        transition: "0.3s",
        "&:focus": {
          color: "#3ac2d7",
          border: "2px solid #3ac2d7",
        },
        "&:hover": {
          backgroundColor: "#3ac2d7",
          color: "#fff",
        },
      },
      saveButton: {
        backgroundColor: "#fff",
        fontFamily: "Montserrat",
        color: "#3ac2d7",
        textTransform: "none",
        width: "200px",
        fontWeight: "bold",
        transition: "0.3s",
        marginLeft: "15px",
        border: "2px solid #3ac2d7",
        "&:hover": {
          backgroundColor: "#3ac2d7",
          color: "#fff",
        },
      },
      offlineButton: {
        fontFamily: "Montserrat",
        fontSize: "16px",
        backgroundColor: "#b499c7",
        color: "#fff",
        transition: "0.5s",
        "&:hover": {
          transform: "translateY(-10px)",
          backgroundColor: "#b499c7",
        },
      },
      onlineButton: {
        fontFamily: "Montserrat",
        fontSize: "16px",
        backgroundColor: "#b499c7",
        color: "#fff",
        opacity: 0.6,
        transition: "0.5s",
        "&:hover": {
          transform: "translateY(-10px)",
          backgroundColor: "#b499c7",
        },
      },
      commonInput: {
        fontFamily: "Montserrat",
        fontWeight: "bold",
        fontSize: "16px",
        color: "rgba(0,0,0,0.5)",
        width: "100%",
        border: "1px solid rgba(0,0,0,0.3)",
        borderRadius: "4px",
        padding: "5px 10px",
        marginBottom: '30px'
      },
      goalLabel: {
        marginBottom: "10px",
        fontSize: "16px",
        fontFamily: "Montserrat",
        fontWeight: "bold",
        textAlign: 'center', 
        width: '100%', 
        color: "#6f59a6",
      },
      goalLabel2: {
        marginTop: '50px !important',
        marginBottom: "10px",
        fontSize: "14px",
        fontFamily: "Montserrat",
        fontWeight: "bold",
        color: "rgba(0,0,0,0.4)",
      },
      listContainer: {
        width: '100%', 
        padding: '20px 10% 100px 10%',
        [theme.breakpoints.down('md')]: {
          padding: '50px 10px 100px 10px'
        }
      }, 
      listOverflow: {
        height: '300px', 
        overflowY: 'scroll', 
        '&::-webkit-scrollbar': {
          width: '0'
        },
        '&::-webkit-scrollbar-track': {
          '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#707070', 
          borderRadius: theme.shape.borderRadius 
        }
      },
      objectFit: {
        objectFit: 'contain'
      },
      checkboxRoot: {
        color: "#3AC2D7 !important",
        "&:hover": {
          backgroundColor: "none",
        },
      },
      searchField: {
        border: '1px solid rgba(0,0,0,0.3)', 
        padding:'3px 10px 3px 50px', 
        fontSize: '16px', 
        fontFamily: "Montserrat",
        borderRadius:'4px',
        margin: '10px 0'
      }
}))

export default useStyles